
export const transition = {
  name: 'transition'
}

export const transitionDuration = {
  name: 'transition-duration'
}

export const transitionProperty = {
  name: 'transition-property'
}

export const transitionTimingFunction = {
  name: 'transition-timing-function'
}